import React, {useEffect} from "react";
import "./Contact.scss";
import { useAnalytics } from "../../customHooks/reactGA";

import Appbar from "../../components/Appbar/Appbar";
import Footer from "../../components/Footer/Footer";
import Form from "../../components/Form/Form";
import { Box } from "@mui/material";

import iconLight from '../../assets/carp_house_plain.png';
import iconDark from '../../assets/carp-house-plain-dark.png';
import Seo from "../../components/Seo/Seo";

const Contact = (props) => {

  const { 
    trackPageView, 
    // trackEvent 
  } = useAnalytics();
    
  useEffect(() => {
    trackPageView('/contact');
  }, [trackPageView]);

  return (
    <div>
      <Seo
        title="Contact Us"
        description="Talk to a CarpHomes team member about selling your Indianapolis house for cash. Call 317-812-1388 or send us a message."
        pathname="/contact"
        />
      <Appbar colorMode={props.colorMode} theme={props.theme} />
      <section
        className="landing"
        style={{
          backgroundColor:
            props.theme.palette.mode === "dark"
              ? props.theme.palette.primary.dark
              : '#e4e4e4',
          backgroundImage:
            props.theme.palette.mode === "dark"
              ? `url(${iconDark})`
              : `url(${iconLight})`
        }}
      >
        <div className="flex-container main-text-container">
          <div>
            <h1
              className="heading-title l1 heading-title--pop"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.warning.main
                    : props.theme.palette.primary.main,
              }}
            >
              Get in Touch with CarpHomes
            </h1>
            <h2 style={{
                color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark,
                fontSize: '1.6rem',
                marginTop: '0.25em'
              }}>
              317-812-1388
            </h2>
            <p
              className="heading-title l2"
              style={{
                color:
                  props.theme.palette.mode === "dark"
                    ? props.theme.palette.common.white
                    : props.theme.palette.primary.dark,
                marginTop: '0.5em'
              }}
            >
              We’re here to answer your questions and help you take the next step. Contact us today to start the process of selling your home quickly and hassle-free.
            </p>
            <p style={{ color: props.theme.palette.mode === "dark" ? props.theme.palette.common.white : props.theme.palette.primary.dark, fontStyle: 'italic', marginTop: '0.5em' }}>
              We respond within one business day. Available Mon-Sat.
            </p>
          </div>
        </div>
      </section>
      <div className="content-wrapper">
        <Box mt={20} mb={20}>
            <Form theme={props.theme} />
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
